export default __webpack_public_path__ + "images/QZ.bee356c.png";